import { FieldWrapper, Label, SingleCombobox } from '@commenda/kakashi';
import { WorkflowStepTrackingCategory } from '@commenda/types';
import { useWorkflow } from '../../context/WorkflowContext';
import { TSelectedEntity } from '../../types/node';

const TRACKING_CATEGORY_OPTIONS = [
  { label: 'Intake', value: WorkflowStepTrackingCategory.INTAKE },
  { label: 'Preparation', value: WorkflowStepTrackingCategory.PREPARATION },
  { label: 'Delivery', value: WorkflowStepTrackingCategory.DELIVERY },
  { label: 'Closeout', value: WorkflowStepTrackingCategory.CLOSEOUT },
];

export const TrackingCategoryProperty = ({
  selectedEntity,
}: {
  selectedEntity: TSelectedEntity;
}) => {
  const { workflow, setWorkflow } = useWorkflow();

  const selectedStep = workflow?.steps.find(
    (step) => step.id === selectedEntity.id
  );

  if (!selectedStep) return null;

  const updateTrackingCategory = (value: string) => {
    setWorkflow({
      ...workflow,
      steps: workflow?.steps.map((step) =>
        step.id === selectedEntity.id
          ? {
              ...step,
              trackingCategory: value
                ? (value as WorkflowStepTrackingCategory)
                : undefined,
            }
          : step
      ),
    });
  };

  return (
    <FieldWrapper>
      <Label>Tracking Category</Label>
      <SingleCombobox
        options={TRACKING_CATEGORY_OPTIONS}
        value={selectedStep.trackingCategory || ''}
        setValue={(value) => updateTrackingCategory(value)}
      />
    </FieldWrapper>
  );
};
